export var translations_IT = {
    AdCode: 'Codice',
    Group: 'Contratto',
    Ipe: 'Ipe',
    EnergyClass: 'Classe Energetica',
    CarPark: 'Posti Auto',
    Rooms: 'Locali',
    Bathrooms: 'Bagni',
    Floor: 'Piano',
    Floors: 'Piani',
    GroundFloor: 'Piano Terra',
    BuildFloorsTotal: 'Numero Piani',
    HasBankLoan: 'Mutuo',
    HasRadiator: 'Riscaldamento',
    HasConditioner: 'Condizionatore',
    HasLift: 'Ascensore',
    IsAnimaladmit: 'Animali Ammessi',
    IsBuildable: 'Edificabile',
    IsBuildableTrue: 'Edificabili',
    IsPanoramic: 'Panoramico',
    BalconyMq: 'Balconi',
    BuildableMq: 'Edificabili',
    ExternalMq: 'Esterni',
    ExternalBuild: 'Giardino',
    ExternalLand: 'Superficie',
    GarageMq: 'Garage',
    CellarMq: 'Cantina',
    InternalMq: 'Interni',
    InternalBuild: 'Superficie',
    TerraceMq: 'Terrazzo',
    CategoryName: 'Categoria',
    TypeName: 'Tipologia',
    POA: 'Trattativa Riservata',
    Social: {
        Facebook: {
            Error: 'Nessuna Pagina Facebook disponibile al momento.'
        }
    },
    Surface: 'Superficie',
    SurfaceRange: 'Superficie in ',
    PriceRange: {
        Range: 'Prezzo',
        label: 'Fascia di Prezzo'
    },
    From: 'da',
    To: 'a',
    Menu: {
        Home: 'Home',
        AboutUs: 'Chi Siamo',
        WhereWeAre: 'Dove Siamo',
        Ads: 'Lista Immobili',
        Service: 'Servizi',
        Contact: 'Contatti',
        News: 'News',
        Privacy: 'Privacy'
    },
    HomeAd: {
        Property: 'Le Nostre Proposte',
        News: 'News'
    },
    ListAd: {
        Tooltips: {
            Adlink: 'Visualizza Scheda',
            Print: 'Stampa Scheda',
            Info: 'Richiedi Informazioni'
        },
        Paging: {
            NotFound: '',
            Found: 'Trovato',
            Founded: 'Trovati',
            Ads: 'Annunci',
            Page: 'Pagina',
            Of: 'di',
            ElementPage: 'Numero Elementi per Pagina'
        }
    },
    SingleAd: {
        Buttons: {
            Tooltips: {
                Print: 'Stampa Scheda',
                Links: 'File Planimetrie'
            },
            Print: 'Stampa',
            Links: 'Planimetrie'
        },
        Price: 'Prezzo',
        Locality_in: ' a ',
        Locality_for: ' in ',
        TableTitle: 'Scheda Annuncio',
        TableTitle_Links: 'Planimetrie',
        labelName: 'Nome File',
        labelDownload: 'Scarica File',
        Title_Slider: 'Immagini Proprieta\'',
        Map: 'Mappa',
        Info: {
            Title: 'Richiedi Informazioni',
            Form: {
                FullName: 'Digita il tuo nome e cognome',
                Email: 'Indirizzo email',
                Number: 'Il tuo recapito telefonico',
                Desc: 'Scrivi qui il tuo messaggio, ti invieremo informazioni dettagliate'
            },
            Label: 'Dichiaro di aver letto ed acconsentire al ',
            Privacy: 'Trattamento Dati',
            Button: 'Invia Richiesta',
            NoImage: 'Nessuna immagine disponibile per questo annuncio',
            NoMap: 'Mappa non disponibile per questo annuncio'
        },
        Agreement: 'Dichiaro di aver letto l\'informativa ed acconsentire al',
        Agreement_2: 'Trattamento Dati',
        Validators: {
            Name: 'Inserisci il Nome',
            Email: 'Inserisci una email valida',
            Phone: 'Inserisci un recapito telefonico valid0',
            Body: 'Inserisci il corpo del messaggio',
            Agreements: 'Devi accettare le condizioni prima di poter inviare la richiesta',
            Subject: 'Inserisci l\'oggetto del messaggio'
        }
    },
    Print: {
        Back: 'Annulla',
        Go: 'Stampa'
    },
    PageStd: {
        LastMod: 'Ultima Modifica'
    },
    News: {
        Title: 'Archivio News',
        Button: 'Continua',
        Back: 'Indietro',
        Paging: {
            NotFound: 'Nessuna',
            Found: 'Trovata',
            Founded: 'Trovate',
            Obj: 'News',
            Page: 'Pagina',
            Of: 'di',
            ElementPage: 'Numero Elementi per Pagina'
        }
    },
    Contact: {
        Form: {
            Title: 'Hai bisogno di informazioni piu\' dettagliate? Contattaci.',
            FullName: 'Digita il tuo nome e cognome',
            Email: 'Indirizzo email',
            Address: 'Indirizzo',
            CityCode: 'CAP',
            City: 'Citta\'',
            Region: 'Provincia',
            Number: 'Il tuo recapito telefonico',
            Fax: 'Fax',
            Obj: 'Oggetto',
            Desc: 'Scrivi qui il tuo messaggio, ti invieremo informazioni dettagliate'
        },
        Label: 'Dichiaro di aver letto ed acconsentire al ',
        Privacy: 'Trattamento Dati',
        Button: 'Invia Richiesta'
    },
    Error404: {
        Title: 'Pagina non Trovata',
        AdError: 'Effettua una nuova ricerca.',
        SlideNone: 'Immagini non presenti nello Slide Show',
        PageNone: 'Pagina in aggiornamento'
    },
    Selects: {
        Empty: '',
        Other: 'Altro',
        Select: 'Seleziona',
        Anything: 'Qualsiasi',
        All: 'Tutti'

    },
    City: 'Comune',
    Search_null: 'Nessun Immobile',
    Search_single: 'Immobile',
    Search_plural: 'Immobili',
    SearchReset: 'Resetta Filtri',
    Toaster: {
        Warning: {
            Code: {
                Title: 'Attenzione!',
                Body: 'Il codice annuncio che hai cercato non esiste, effettua una nuova ricerca.'
            }
        },
       Success: {
            Contact: {
                Title: 'Invia Richiesta',
                Body: 'La richiesta di informazioni e\' stata inviata'
            }
        }
    },
    Yes: 'Si',
    No: 'No',
    Of: 'di',
    Prev: 'Precedente',
    Next: 'Successivo',
    ImgNewTab: 'Apri immagine in un altra tab'

};
export var translations_EN = {
    AdCode: 'Code',
    Group: 'Contract',
    Ipe: 'Ipe',
    EnergyClass: 'Energetic Class',
    CarPark: 'Car Parks',
    Rooms: 'Rooms',
    Bathrooms: 'Bathrooms',
    Floor: 'Floor',
    Floors: 'Floors',
    GroundFloor: 'Ground floor',
    BuildFloorsTotal: 'Total Floors',
    HasBankLoan: 'Bank Loan',
    HasRadiator: 'Radiators',
    HasConditioner: 'Conditioner',
    HasLift: 'Lift',
    IsAnimaladmit: 'Animal Admit',
    IsBuildable: 'Buildable',
    IsBuildableTrue: 'Buildable',
    IsPanoramic: 'Panoramic',
    BalconyMq: 'Balcony',
    BuildableMq: 'Buildable',
    ExternalMq: 'External',
    ExternalBuild: 'Garden',
    ExternalLand: 'Surface',
    GarageMq: 'Garage',
    CellarMq: 'Cellar',
    InternalMq: 'Internal',
    InternalBuild: 'Surface',
    TerraceMq: 'Terrace',
    CategoryName: 'Category',
    TypeName: 'Tipology',
    Social: {
        Facebook: {
            Error: 'There are not Facebook Pages avaiable for now.'
        }
    },
    Surface: 'Surface',
    SurfaceRange: 'Surface in ',
    PriceRange: {
        label: 'Price Range',
        Range: 'Price'
    },
    POA: 'Private Negotiation',
    From: 'from',
    To: 'to',
    Menu: {
        Home: 'Home',
        AboutUs: ' About Us',
        WhereWeAre: 'Where we are',
        Ads: 'Advertisements',
        Service: 'Services',
        Contact: 'Contacts',
        News: 'News',
        Privacy: 'Privacy'
    },
    HomeAd: {
        Property: 'Our Properties',
        News: 'News'
    },
    ListAd: {
        Tooltips: {
            Adlink: 'View Property',
            Print: 'Print Property Form',
            Info: 'Request Information'
        },
        Paging: {
            NotFound: '',
            Found: 'Found',
            Founded: 'Founded',
            Ads: 'Properties',
            Page: 'Page',
            Of: 'of',
            ElementPage: 'Number elements Page'
        }
    },
    SingleAd: {
        Buttons: {
            Tooltips: {
                Print: 'Print',
                Links: 'Floorplans File'
            },
            Print: 'Print',
            Links: 'Floorplans'
        },
        Price: 'Price',
        Locality_in: ' in ',
        Locality_for: ' for ',
        TableTitle: 'Advertisement',
        TableTitle_Links: 'Floorplans',
        labelName: 'File Name',
        labelDownload: 'Download File',
        Title_Slider: 'Property Images',
        Map: 'Map',
        Info: {
            Title: 'Information Request',
            Form: {
                FullName: 'Enter your name',
                Email: 'Email Address',
                Number: 'Your telephone number',
                Desc: 'Write your message here, we will send you more detailed information'
            },
            Label: 'I have read and agree to ',
            Privacy: 'Data Treatment',
            Button: 'Send Request',
            NoImage: 'No Images avaiable for this ad',
            NoMap: 'No Map avaiable for this ad'
        },
        Agreement: 'I declare to have read and agree to the ',
        Agreement_2: 'Data Treatment',
        Validators: {
            Name: 'Insert name',
            Email: 'Insert a valid email',
            Phone: 'Insert a valid phone number',
            Body: 'Insert body of message',
            Agreements: 'You must agree to the conditions before you can send the request',
            Subject: 'Insert Subject of message'
        }
    },
    Print: {
        Back: 'Back',
        Go: 'Print'
    },
    PageStd: {
        LastMod: 'Last Modified'
    },
    News: {
        Title: 'News Archive',
        Button: 'Read more ',
        Back: 'Back',
        Paging: {
            NotFound: 'No',
            Found: 'Found',
            Founded: 'Founded',
            Obj: 'News',
            Page: 'Page',
            Of: 'of',
            ElementPage: 'Number elements Page'
        }
    },
    Contact: {
        Form: {
            Title: 'Need more detailed information? Contact.',
            FullName: 'Enter your name',
            Email: 'Email Address',
            Address: 'Address',
            CityCode: 'Zip Code',
            City: 'City',
            Region: 'Province',
            Number: 'Your telephone number',
            Fax: 'Fax',
            Obj: 'Subject',
            Desc: 'Write your message here, we will send you more detailed information'
        },
        Label: 'I have read and agree to ',
        Privacy: 'Data Treatment',
        Button: 'Send Request'
    },
    Error404: {
        Title: 'Page not Found',
        AdError: 'Start a new search.',
        SlideNone: 'In the Slide Show images not present',
        PageNone: 'Page is under construction'
    },
    Selects: {
        Empty: '',
        Other: 'Other',
        Select: 'Select',
        Anything: 'Any',
        All: 'All'
    },
    City: 'City',
    Search_null: 'No Advertisement',
    Search_single: 'Advertisement',
    Search_plural: 'Advertisements',
    SearchReset: 'Filter Reset',
    Toaster: {
        Warning: {
            Code: {
                Title: 'Warning!',
                Body: 'The ad code you searched for does not exist, start a new search.'
            }
        },
        Success: {
            Contact: {
                Title: 'Invia Richiesta',
                Body: 'La richiesta di informazioni è stata inviata'
            }
        }
    },
    Yes: 'Yes',
    No: 'No',
    Of: 'di',
    Prev: 'Previous',
    Next: 'Next',
    ImgNewTab: 'Open image in new tab'
};



// WEBPACK FOOTER //
// A:/Work/Siti/Volpe2/src/app/common/vars_translate.ts